import React, { PropsWithChildren, useState } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

type Props = {
  onDelete: () => void;
};

const StepItem = ({ children, onDelete }: PropsWithChildren<Props>) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={1}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
      <IconButton
        onClick={onDelete}
        aria-label="Remove step"
        sx={{
          opacity: hovered ? 1 : 0,
          transition: 'opacity 0.2s',
        }}
      >
        <DeleteIcon />
      </IconButton>
    </Box>
  );
};

export default StepItem;
